import { trpc } from "@/lib/trpc";
import { useAuth } from "@/_core/hooks/useAuth";

export function useFocusMasterTokenLock() {
 const { user } = useAuth();
 
 const tokenQuery = trpc.settings.checkSavedFocusToken.useQuery(undefined, {
 enabled: !!user,
 staleTime: 1000 * 60 * 5, // 5 min cache
 });

 return {
 isTokenInvalid: tokenQuery.isSuccess && !tokenQuery.data.valid,
 isLoading: tokenQuery.isLoading,
 };
}
